<div class="footer" *transloco="let t; read: 'landing.footer'">
  <div class="footer__top">
    <div class="footer__links-wrapper">
      <ul class="footer__links">
        <li class="footer__copyright">{{ t(copyrightKey(), { year: currentYear }) }}</li>
        <li class="footer__dot coloured-dot footer__dot--after-copyright"></li>
        <li class="footer__link-item">
          <a href="https://brightfunded.com/privacy-policy" target="_blank" class="footer__link">{{
            t("link.privacyPolicy")
          }}</a>
        </li>
        <li class="footer__dot coloured-dot"></li>
        <li class="footer__link-item">
          <a
            href="https://brightfunded.com/terms-and-conditions"
            target="_blank"
            class="footer__link"
            >{{ t("link.termsAndConditions") }}</a
          >
        </li>
        <li class="footer__dot coloured-dot"></li>
        <li class="footer__link-item">
          <a
            href="https://brightfunded.com/terms-and-conditions"
            target="_blank"
            class="footer__link"
            >{{ t("link.riskDisclosure") }}</a
          >
        </li>
      </ul>
    </div>
  </div>

  <div class="footer__separator"></div>

  <div class="footer__description">
    <p class="footer__desc-text">{{ t("shortDescription") }}</p>
    <button
      class="footer__expand-btn"
      [class.footer__expand-btn--open]="textVisible"
      (click)="additionalText()"
    >
      <app-svg-icon icon="assets/images/icon-chevron.svg" [blank]="true" />
    </button>
  </div>
  <div class="footer__long-desc" [class.footer__long-desc--expanded]="textVisible">
    <p class="footer__long-desc-text" [innerHTML]="t('longDescription') | lineBreaks"></p>
  </div>
  <div id="targetElement"></div>
</div>
